import 'shows/truncateToHeight';

export default function () {
    let el = document.getElementById('js-about-copy');

    if (el && typeof el.style.webkitLineClamp === 'undefined') {
        TruncateToHeight.truncate({
            heightElementId: 'js-about-description',
            contentElementId: 'js-about-copy',
            limit: 2000
        });
    }
}
